var _excluded = ["ribbon", "children"];

var _templateObject, _templateObject2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { string, shape, oneOf, node } from 'prop-types';
import Text from '../../../Text';
var CardStyled = styled.section(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
      _ref$theme$yoga = _ref.theme.yoga,
      color = _ref$theme$yoga.colors[variant],
      card = _ref$theme$yoga.components.card;
  return "\n  padding: \n    " + card.padding.top + "px \n    " + card.padding.right + "px \n    " + card.padding.bottom + "px \n    " + card.padding.left + "px;\n\n  border-radius: " + card.radii + "px;\n  background-color: " + (variant ? color : card.backgroundColor) + ";\n  box-shadow: " + card.elevation + ";\n";
});
var Ribbon = styled(Text.Tiny)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var variant = _ref2.variant,
      _ref2$theme$yoga = _ref2.theme.yoga,
      card = _ref2$theme$yoga.components.card,
      spacing = _ref2$theme$yoga.spacing,
      _ref2$theme$yoga$colo = _ref2$theme$yoga.colors,
      elements = _ref2$theme$yoga$colo.elements,
      color = _ref2$theme$yoga$colo[variant],
      white = _ref2$theme$yoga$colo.white,
      text = _ref2$theme$yoga$colo.text;
  return "\n  display: inline-block;\n  top: " + card.padding.top + "px;\n  left: 0;\n\n  margin-left: -" + card.padding.left + "px;\n  margin-bottom: " + card.padding.bottom + "px;\n\n  padding: \n    " + spacing.xxxsmall + "px\n    " + spacing.xsmall + "px\n    " + spacing.xxxsmall + "px\n    " + spacing.small + "px;\n  \n  border-top-right-radius: " + card.ribbon.radius + "px;\n  border-bottom-right-radius: " + card.ribbon.radius + "px;\n\n  background-color: " + (variant ? color : elements.backgroundAndDisabled) + ";\n\n  color: " + (variant ? white : text.primary) + ";\n  ";
});
var Card = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var ribbon = _ref3.ribbon,
      children = _ref3.children,
      rest = _objectWithoutPropertiesLoose(_ref3, _excluded);

  return /*#__PURE__*/React.createElement(CardStyled, _extends({
    ref: ref
  }, rest), Object.keys(ribbon).length > 0 && /*#__PURE__*/React.createElement(Ribbon, {
    variant: ribbon.variant,
    as: "span"
  }, ribbon.text), children);
});
Card.propTypes = {
  /** text: the content inside the Card Ribbon.
   * variant: style the card following the theme (primary, secondary, vibin, hope,
   * energy, relax, peace, verve, uplift, deepPurple, deep, stamina, dark,
   * medium, light, clear, white) */
  ribbon: shape({
    text: string,
    variant: oneOf(['', 'primary', 'secondary', 'vibin', 'hope', 'energy', 'relax', 'peace', 'verve', 'uplift', 'deepPurple', 'stamina', 'dark', 'medium', 'deep', 'light', 'clear', 'white'])
  }),
  children: node
};
Card.defaultProps = {
  ribbon: {},
  children: null
};
Card.displayName = 'Card';
export default Card;